module.exports = __webpack_public_path__ + "static/media/recycle_folder.3aa560e3.ico";